import React from "react";
import "./SignUp.css";

import { Button, makeStyles, TextField } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px",
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2),
    },
  },
}));

const SignUp = ({
  signUp,
  username,
  setUserName,
  email,
  setEmail,
  password,
  setPassword,
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className=' form mx-auto flex justify-center items-center  flex-col'>
      <form className={`${classes.root} bg-white h-96 shadow-xl rounded-xl`}>
        <TextField
          label='User Name'
          value={username}
          onChange={(e) => setUserName(e.target.value)}
          variant='filled'
          required
        />
        <TextField
          label='Email'
          variant='filled'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type='email'
          required
        />
        <TextField
          label='Password'
          className='bg-white'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          variant='filled'
          type='password'
          required
        />

        <div className='pt-3'>
          <Button
            className='px-3 text-color'
            variant='contained'
            onClick={() => history.push("/")}>
            Go Back
          </Button>
          <Button
            className='signUp'
            type='submit'
            variant='contained'
            color='primary'
            onClick={signUp}>
            Signup
          </Button>
        </div>
        <p>
          Already have an account?{" "}
          <span
            className='font-bold cursor-pointer'
            onClick={() => history.push("/signIn")}>
            Login
          </span>
        </p>
      </form>
    </div>
  );
};

export default SignUp;
